import { gql } from '@apollo/client'

const USE_USER_PROFILE_FRAGMENT = gql`
  fragment UseUserProfileFragment on UserProfile {
    id
    idCode
    email
    verified
    firstName
    lastName
    verifications {
      consumerGroup
      expiresAt
      status
      institution {
        name
      }
    }
  }
`

export const USE_USER_PROFILE_QUERY = gql`
  query UseUserProfileQuery {
    accountsViewer {
      isLoggedIn
      userProfile {
        ...UseUserProfileFragment
      }
    }
  }
  ${USE_USER_PROFILE_FRAGMENT}
`
